<template>
  <DefaultBackground>
    <section v-if="event" class="m-2 md:m-10">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row items-start">
          <div class="bg-white rounded-lg shadow-card w-full mr-4 mb-4">
            <header class="px-6 py-4">
              <router-link :to="{name: 'events.index'}">
                <img
                    alt="BuildaBox Individual Order Details Navigation Back"
                    class="inline-block"
                    src="@/assets/images/ic_arrow_back.svg"
                />
                <span class="text-primary font-semibold ml-3">Back to Events</span>
              </router-link>
              <h1 class="font-semibold text-2xl lg:text-3xl mt-3 text-center lg:text-left">
                Individual Order Details
              </h1>
            </header>
            <header class="border-t border-light-gray px-6 py-4">
              <div class="flex items-center">
                <div class="w-48">
                  <span>Order ID #</span>
                  <span class="ml-10 text-gray-600">{{ event.id }}</span>
                </div>
                <div class="text-sm w-48">
                  <OrderStatus :order="event"></OrderStatus>
                </div>
              </div>
            </header>
            <header class="border-t border-light-gray px-6 py-3">
              <OrderStatusBar :event="event"></OrderStatusBar>
            </header>
            <section class="flex flex-col lg:flex-row mt-5">
              <div class="px-6">
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">USER NAME</div>
                  <div>{{ event.owner.full_name }}</div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0">EVENT NAME</div>
                  <div>{{ event.name }}</div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">EVENT ADDRESS</div>
                  <div>{{ event.address }}</div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">EVENT LOCATION</div>
                  <div>{{ event.delivery_location }}</div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">State and City</div>
                  <div>{{ event.state }}, {{ event.city }}</div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">Phone</div>
                  <div>{{ event.phone }}</div>
                </div>

              </div>
              <div class="px-6 lg:ml-16">
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0">
                    TIMEZONE
                  </div>
                  <div>
                    {{ event.timezone }}
                  </div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">EVENT START Date</div>
                  <div v-if="event.start">
                    {{ formatDate(event.start) }}
                  </div>
                  <div v-else class="text-gray-500">
                    No Start Date
                  </div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">EVENT END Date</div>
                  <div v-if="event.end">
                    {{ formatDate(event.end) }}
                  </div>
                  <div v-else class="text-gray-500">
                    No END Date
                  </div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0 uppercase">EVENT Delivery Date</div>
                  <div v-if="event.delivery_time">
                    {{ formatDate(event.end) }}
                  </div>
                  <div v-else class="text-gray-500">
                    No END Date
                  </div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0">DATE/TIME SENT</div>
                  <div v-if="event.invitation && event.invitation.sent_at">
                    {{ formatDate(event.invitation.sent_at) }}
                  </div>
                  <div v-else class="text-gray-500">
                    No Date
                  </div>
                </div>
                <div class="flex flex-col md:flex-row mt-5">
                  <div class="text-sm text-gray-600 w-40 flex-shrink-0">DATE/TIME ORDER ENTERED</div>
                  <div v-if="event.sub_order.created_at">
                    {{ formatDate(event.sub_order.created_at) }}
                  </div>
                  <div v-else class="text-gray-500">
                    No Date
                  </div>
                </div>


              </div>
            </section>

            <section class="my-5 pb-10">
              <div v-if="loadingCategories">
                <Spinner class="mx-auto" orange></Spinner>
              </div>
              <div v-else>
                <div
                    v-for="category in categories"
                    :key="category.uuid"
                    class="px-6 py-3 mt-5 border-t border-light-gray"
                >
                  <header>
                    <div class="text-sm text-gray-600">
                      {{ category.name }}
                    </div>
                  </header>
                  <div class="mt-3 ml-3">
                    <div v-for="item in category.orderedItems" :key="item.uuid" class="mb-3">
                      - {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="bg-white rounded-lg shadow-card p-8 sm:p-12 w-full md:w-68 flex-shrink-0">
            <h1 class="mb-3 font-semibold text-lg">
              Promote You
            </h1>
            <p>
              Share the social media links for this event across your network to let everyone know and help get the word
              out.
            </p>
            <button :disabled="!canPromoteEvent(event)"
                    class="btn btn-primary font-semibold rounded w-full px-10 mt-5"
                    @click="showPromoteModal = true">
              Promote You
            </button>
          </div>
        </div>
      </div>
      <Modal v-if="showPromoteModal">
        <div slot="header">
          <div class="text-right">
            <button class="button" @click="showPromoteModal = false">✖</button>
          </div>
        </div>
        <div slot="body">
          <promote :event="event"></promote>
        </div>
        <div slot="footer"></div>
      </Modal>
    </section>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from '@/components/common/layout/DefaultBackground'
import OrderStatusBar from '@/components/order/OrderStatusBar'
import Api from '@/api/api_v1.0'
import OrderStatus from '@/components/common/OrderStatus'
import moment from 'moment-timezone'
import Modal from '@/components/common/Modal'
import Promote from '@/views/events/uuid/promote'
import Spinner from '@/components/common/Spinner'

export default {
  components: {
    Spinner,
    Promote,
    Modal,
    OrderStatus,
    OrderStatusBar,
    DefaultBackground
  },
  data () {
    return {
      event            : '',
      categories       : [],
      loading          : false,
      loadingCategories: false,
      showPromoteModal : false
    }
  },
  async mounted () {
    this.loading = true
    const response = await Api.getEventDetails(this.$route.params.uuid)
    this.event = response.data

    this.loading = false
    this.loadSubOrderCategories()
  },
  methods: {
    canPromoteEvent (event) {
      return !!(event.facebook_link || event.twitter_link || event.linkedin_link)
    },
    formatDate (timestamp) {
      if (!timestamp) {
        return ''
      }
      return moment(timestamp).tz(this.event.timezone).format('MMM DD, YYYY, hh:mm A')
    },
    loadSubOrderCategories () {
      this.loadingCategories = true
      Api.getAttendeeDetailsOfOrder(this.event.uuid, this.event.sub_order.attendee_id).then((response) => {
        this.loadingCategories = false
        console.log(response.data.sub_order, 'Suborder')
        this.categories = this.assembleCategories(response.data.sub_order)
      }).catch(() => {
        this.loadingCategories = false
      })
    },
    assembleCategories (subOrders) {
      let categories = {}

      subOrders.items.map(subOrder => {
        if (categories[subOrder.category.id] === undefined)
          categories[subOrder.category.id] = { ...subOrder.category }

        let item = { ...subOrder.item }

        categories[subOrder.category.id].orderedItems ?
            categories[subOrder.category.id].orderedItems.push(item) :
            categories[subOrder.category.id].orderedItems = [item]

      })

      return categories
    },
  }
}
</script>